import { config } from "../../config/config";
import { Observable } from "rxjs";
import { utilService } from "../utils";

/**
 * Api services for admin component
 */
export const adminService = {
  getCategoires,
  saveConnectionHeader,
  fetchConnectionHeader,
  updateConnectionHeader,
  deleteConnectionHeader,
};

function getCategoires(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.post_categories + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        return result.returnData;
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function saveConnectionHeader(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.connection_headers, {
      method: "POST",
      headers: {
        Authorization: data.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data.data),
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function updateConnectionHeader(data) {
  return Observable.create((observer) => {
    fetch(
      config.api_url +
        config.url.connection_headers +
        data.data.connectionheaderUid,
      {
        method: "PUT",
        headers: {
          Authorization: data.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data.data),
      }
    )
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function deleteConnectionHeader(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.connection_headers + data.id, {
      method: "DELETE",
      headers: {
        Authorization: data.token,
        "Content-Type": "application/json",
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

function fetchConnectionHeader(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.connection_headers, {
      method: "GET",
      headers: {
        Authorization: data.token,
        "Content-Type": "application/json",
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
